// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file vision/generations/v1/regenerate_generation.proto (package protos.vision.generations.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { CreditSource } from "../../billing/v1/vision_billing_pb";
import { file_vision_billing_v1_vision_billing } from "../../billing/v1/vision_billing_pb";
import type { GenerationStatus } from "./vision_generation_pb";
import { file_vision_generations_v1_vision_generation } from "./vision_generation_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file vision/generations/v1/regenerate_generation.proto.
 */
export const file_vision_generations_v1_regenerate_generation: GenFile = /*@__PURE__*/
  fileDesc("CjF2aXNpb24vZ2VuZXJhdGlvbnMvdjEvcmVnZW5lcmF0ZV9nZW5lcmF0aW9uLnByb3RvEhxwcm90b3MudmlzaW9uLmdlbmVyYXRpb25zLnYxIs8BChtSZWdlbmVyYXRlR2VuZXJhdGlvblJlcXVlc3QSUAoGcGFyYW1zGAEgASgLMkAucHJvdG9zLnZpc2lvbi5nZW5lcmF0aW9ucy52MS5SZWdlbmVyYXRlR2VuZXJhdGlvblJlcXVlc3QuUGFyYW1zGl4KBlBhcmFtcxIVCg1nZW5lcmF0aW9uX2lkGAEgASgJEj0KDWNyZWRpdF9zb3VyY2UYAiABKA4yJi5wcm90b3MudmlzaW9uLmJpbGxpbmcudjEuQ3JlZGl0U291cmNlItIBChxSZWdlbmVyYXRlR2VuZXJhdGlvblJlc3BvbnNlElEKBnJlc3VsdBgBIAEoCzJBLnByb3Rvcy52aXNpb24uZ2VuZXJhdGlvbnMudjEuUmVnZW5lcmF0ZUdlbmVyYXRpb25SZXNwb25zZS5SZXN1bHQaXwoGUmVzdWx0EhUKDWdlbmVyYXRpb25faWQYASABKAkSPgoGc3RhdHVzGAIgASgOMi4ucHJvdG9zLnZpc2lvbi5nZW5lcmF0aW9ucy52MS5HZW5lcmF0aW9uU3RhdHVzYgZwcm90bzM", [file_vision_billing_v1_vision_billing, file_vision_generations_v1_vision_generation]);

/**
 * @generated from message protos.vision.generations.v1.RegenerateGenerationRequest
 */
export type RegenerateGenerationRequest = Message<"protos.vision.generations.v1.RegenerateGenerationRequest"> & {
  /**
   * @generated from field: protos.vision.generations.v1.RegenerateGenerationRequest.Params params = 1;
   */
  params?: RegenerateGenerationRequest_Params | undefined;
};

/**
 * Describes the message protos.vision.generations.v1.RegenerateGenerationRequest.
 * Use `create(RegenerateGenerationRequestSchema)` to create a new message.
 */
export const RegenerateGenerationRequestSchema: GenMessage<RegenerateGenerationRequest> = /*@__PURE__*/
  messageDesc(file_vision_generations_v1_regenerate_generation, 0);

/**
 * @generated from message protos.vision.generations.v1.RegenerateGenerationRequest.Params
 */
export type RegenerateGenerationRequest_Params = Message<"protos.vision.generations.v1.RegenerateGenerationRequest.Params"> & {
  /**
   * @generated from field: string generation_id = 1;
   */
  generationId: string;

  /**
   * @generated from field: protos.vision.billing.v1.CreditSource credit_source = 2;
   */
  creditSource: CreditSource;
};

/**
 * Describes the message protos.vision.generations.v1.RegenerateGenerationRequest.Params.
 * Use `create(RegenerateGenerationRequest_ParamsSchema)` to create a new message.
 */
export const RegenerateGenerationRequest_ParamsSchema: GenMessage<RegenerateGenerationRequest_Params> = /*@__PURE__*/
  messageDesc(file_vision_generations_v1_regenerate_generation, 0, 0);

/**
 * @generated from message protos.vision.generations.v1.RegenerateGenerationResponse
 */
export type RegenerateGenerationResponse = Message<"protos.vision.generations.v1.RegenerateGenerationResponse"> & {
  /**
   * @generated from field: protos.vision.generations.v1.RegenerateGenerationResponse.Result result = 1;
   */
  result?: RegenerateGenerationResponse_Result | undefined;
};

/**
 * Describes the message protos.vision.generations.v1.RegenerateGenerationResponse.
 * Use `create(RegenerateGenerationResponseSchema)` to create a new message.
 */
export const RegenerateGenerationResponseSchema: GenMessage<RegenerateGenerationResponse> = /*@__PURE__*/
  messageDesc(file_vision_generations_v1_regenerate_generation, 1);

/**
 * @generated from message protos.vision.generations.v1.RegenerateGenerationResponse.Result
 */
export type RegenerateGenerationResponse_Result = Message<"protos.vision.generations.v1.RegenerateGenerationResponse.Result"> & {
  /**
   * @generated from field: string generation_id = 1;
   */
  generationId: string;

  /**
   * @generated from field: protos.vision.generations.v1.GenerationStatus status = 2;
   */
  status: GenerationStatus;
};

/**
 * Describes the message protos.vision.generations.v1.RegenerateGenerationResponse.Result.
 * Use `create(RegenerateGenerationResponse_ResultSchema)` to create a new message.
 */
export const RegenerateGenerationResponse_ResultSchema: GenMessage<RegenerateGenerationResponse_Result> = /*@__PURE__*/
  messageDesc(file_vision_generations_v1_regenerate_generation, 1, 0);

